import getConfig from '~/config';
import SuperAdminLayout from '../common/SuperAdminLayout';
import ClearEsriCache from './ClearEsriCache';
import IntelligenceTools from './IntelligenceTools';
import LoadStagingLayerCatalog from './LoadStagingLayerCatalog';
import NotificationTools from './NotificationTools';
import PostHogTools from './PostHogTools';
import RefreshTileConfig from './RefreshTileConfig';
import RefreshTiles from './RefreshTiles';
import RunAgencyLoader from './RunAgencyLoader';

const config = getConfig();

function Separator() {
  return <hr className="my-8 border-b border-t-0 border-grey-20" />;
}

export default function Tools() {
  return (
    <SuperAdminLayout>
      <div className="flex flex-col space-y-4">
        <RunAgencyLoader />
        <ClearEsriCache />
        <RefreshTiles />
        <RefreshTileConfig />
        {config.env === 'dev' && <LoadStagingLayerCatalog />}
      </div>
      <Separator />
      <div className="flex flex-col space-y-4">
        <div className="text-lg font-medium">Notification Tools</div>
        <NotificationTools />
      </div>
      <Separator />
      <div className="flex flex-col space-y-4">
        <div className="text-lg font-medium">Intelligence Tools</div>

        <IntelligenceTools />
      </div>
      <Separator />
      <PostHogTools />
    </SuperAdminLayout>
  );
}
